import { useRef, useEffect, ReactNode } from 'react';
import { useState } from "react"
import { ChevronRightIcon } from '@heroicons/react/outline';
import "./index.css"
interface CollapseProps {
  id?: string;
  className?: string;
  header: string;
  children?: ReactNode | ReactNode[];
  defaultOpen?: boolean;
  headerClass?: string;
  headerRightIcon?: ReactNode
}
const Collapse: React.FC<CollapseProps> = ({
  id,
  className,
  children,
  header,
  headerClass,
  defaultOpen = false,
  headerRightIcon
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);        //初始化展开收起，默认收起
  const collapseRef = useRef(null);
  // const collapseSection = (element: HTMLDivElement) => {
  //   const sectionHeight = element.scrollHeight;
  //   requestAnimationFrame(function () {
  //     element.style.height = sectionHeight + 'px';
  //     requestAnimationFrame(function () {
  //       element.style.height = 0 + 'px';
  //     });
  //   });

  // };
  // const expandSection = (element: HTMLDivElement) => {
  //   const sectionHeight = element.scrollHeight;
  //   element.style.height = sectionHeight + 'px';
  //   let clearTime = setTimeout(() => {
  //     element.style.height = 'auto';
  //   }, 400); clearTimeout(clearTime);
  // };
  useEffect(() => {
    const element = collapseRef.current!;
    // if (isOpen) expandSection(element);
    // else collapseSection(element);
  }, [isOpen]);
  return (
    <div id={id}
      className={`${className}`}
    >
      <header className={`flex items-center justify-between cursor-pointer p-2 transition-all duration-200
          ${headerClass} ${isOpen ? 'mb-2' : ''}
        `}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{header}</span>
        <div className='flex'>
          {headerRightIcon}
          <ChevronRightIcon className={`w-3 h-3 transform duration-100 ${isOpen ? 'rotate-90' : 'rotate-0'}`} />
        </div>
      </header>
      <div ref={collapseRef} className={`${className} overflow-hidden transition-all duration-200 px-2 ${isOpen? 'show-collapse': 'hide-collapse'}`}>
        {children}
      </div>
    </div>
  );
};
export default Collapse;
